import { OverviewMetricsReportDto } from "./overview-metrics-report-dto";

export class InstagramMetricsReportDto extends OverviewMetricsReportDto {

  public Posts: Array<any>[];
  public TotalLikes: number;
  public TotalReach: number;
  public TotalViews: number;
  public TotalComments: number;
  public TotalSaved: number;
  public TotalImpressions: number;

  constructor(init: {
    Posts: Array<any>[],
    TotalLikes: number,
    TotalReach: number,
    TotalViews: number,
    TotalComments: number,
    TotalSaved: number,
    TotalImpressions: number;
    TotalPosts: number;
    TotalFollowers: number;
    EngagementRate: number;    
  }) {
    super(init);
    this.Posts = init.Posts;
    this.TotalLikes = init.TotalLikes;
    this.TotalReach = init.TotalReach;
    this.TotalViews = init.TotalViews;
    this.TotalComments = init.TotalComments;
    this.TotalSaved = init.TotalSaved;
  }
}  